


















































import { Component, Vue, Prop, Inject, Ref, Watch } from "vue-property-decorator";
import { ITileContainer } from "./ITileContainer";
import { GridItem, GridLayout } from "vue-grid-layout";
import { Debounce } from "vue-debounce-decorator";

const COL_NUM = 6;
const ROW_NUM = 6;
const MARGIN_X = 24;
const MARGIN_Y = 24;

@Component({
    components: {
        GridLayout,
        GridItem,
    },
    directives: {
        scroll: {
            inserted(el) {
                el.scrollIntoView({block: "end", inline: "nearest", behavior: "smooth"});
            },
        }
    }
})
export default class TileContainer extends Vue {
    @Ref("tile-container") tileContainer!: HTMLDivElement;

    @Inject({ default: null }) readonly closeCurrentView!: () => void;

    @Prop({ type: Boolean }) public editable!: boolean;
    @Prop() value!: ITileContainer[];
    @Prop({ type: Boolean }) verticalCompact!: boolean;

    private colNum = COL_NUM;
    private rowHeight = 0;
    private resizeObserver: ResizeObserver | null = null;
    private timerId: number | null = null;
    private isOutOfWindow = false;

    private windowHTML: HTMLElement | null = null;
    private resizeWindowObserver: ResizeObserver | null = null;
    private resizeWindowTimerId: number | null = null;
    private windowWidth = 0;
    private smWidth = 640;
    private mdWidth = 768;
    private lgWidth = 1024;
    private xlWidth = 1280;
    private xxlWidth = 1536;
    private isSM = false;

    private get marginX(): number {
        return !this.isSM ? MARGIN_X : 0;
    }
    private get marginY(): number {
        return !this.isSM ? MARGIN_Y : 0;
    }
    private get magicNumber(): number {
        return !this.isSM ? (this.marginY * ROW_NUM + this.marginY) : 0;
    }

    private geTileIdentifier(tileIdWithPayload: string): string {
        const pos = tileIdWithPayload.indexOf(":");
        if (pos > -1) {
            return tileIdWithPayload.substring(0, pos);
        }
        return tileIdWithPayload;
    }

    private geTilePayload(tileIdWithPayload: string): string | null {
        const pos = tileIdWithPayload.indexOf(":");
        if (pos > -1) {
            return tileIdWithPayload.substring(pos + 1);
        }
        return null;
    }

    private get content() {
        if (!this.value) {
            return [];
        }

        if (this.value.some((el) => !el.i)) {
            return this.value.map((el) => ({ ...el, i: el.i || el.x + "-" + el.y }));
        }
        return this.value;
    }

    private set content(val: ITileContainer[]) {
        this.$emit("input", val);
    }

    mounted() {
        this.rowHeight = Math.floor((this.tileContainer.clientHeight - this.magicNumber) / ROW_NUM);
        if(this.editable){
            window.addEventListener("mousedown", this.onMouseDown);
        }
        this.addWindowWidthObserver();
    }

    destroyed(){
        if(this.editable){
            window.removeEventListener("mousedown", this.onMouseDown);
        }
        this.resetWindowWidthObserver();
    }

    private get hiddenElHeight(){
        return {
            height: this.rowHeight + 'px'
        }
    }

    onMouseDown(e: MouseEvent){
        const elClicked = e.target as HTMLElement;
        if(elClicked && elClicked.className === "vue-resizable-handle"){
            window.addEventListener("mousemove", this.onMouseMove);
            window.addEventListener("mouseup", this.onResizeEnd);
        }
    }

    onMouseMove(e: MouseEvent) {
        if (e.clientY + 5 > window.innerHeight) {
            this.isOutOfWindow = true;
        } else if (this.isOutOfWindow) {
            this.isOutOfWindow = false;
        }
    }

    onResizeEnd(){
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onResizeEnd);
        this.isOutOfWindow = false;
    }

    onCloseModal() {
        if (this.closeCurrentView) {
            this.closeCurrentView();
        }
    }

    @Debounce(200)
    changeRowHeight() {
        this.rowHeight = Math.floor((this.tileContainer.clientHeight - this.magicNumber) / ROW_NUM);
    }

    private resetWindowWidthObserver() {
        if (this.resizeWindowTimerId !== null) {
            clearInterval(this.resizeWindowTimerId);
            this.resizeWindowTimerId = null;
        } else if (this.resizeWindowObserver !== null) {
            this.resizeWindowObserver.disconnect();
            this.resizeWindowObserver = null;
        }
    }
    private addWindowWidthObserver() {
        this.windowHTML = this.$refs.app_container as HTMLElement;
        if (window.ResizeObserver && this.windowHTML) {
            this.resizeWindowObserver = new ResizeObserver((/* elements */) => this.windowWidth = this.windowHTML!.clientWidth);
            this.resizeWindowObserver.observe(this.windowHTML);
        } else {
            this.resizeWindowTimerId = window.setInterval(() => this.windowWidth = this.windowHTML!.clientWidth, 500);
        }
    }

    @Debounce(100)
    @Watch("windowWidth")
    private onWindowWidthUpdate(){
        if(this.windowWidth > this.xxlWidth){
            this.isSM = false;
        } else if(this.windowWidth > this.xlWidth) {
            this.isSM = false;
        } else if(this.windowWidth > this.lgWidth) {
            this.isSM = false;
        } else if(this.windowWidth > this.mdWidth) {
            this.isSM = false;
        } else {
            this.isSM = true;
        }
    }

}
